import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { Router, NavigationStart } from '@angular/router';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	bIsPageLoad: boolean;
	strCurrentPageName: string;
	arrStrPageListTargeted: string[];

	constructor(_router: Router) {
		console.log('environment: ');
		console.log(environment);

		this.bIsPageLoad = false;
		this.strCurrentPageName = '';
		this.arrStrPageListTargeted = ['estimate', 'more', 'welcome'];

		_router.events.subscribe((event) => {
			let strUrl = (event as any).url.toString();
			let arr = strUrl.split('/');
			arr.shift();
			if(arr.length > 0) {
				if(event instanceof NavigationStart) {
					this.strCurrentPageName = arr[0];
					this.bIsPageLoad = true;
				}
			} else {
				console.log('The url is not correct.');
			}
		});
	}
}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/app.component.ts